import { h, VNode, Fragment, ComponentChildren, FunctionComponent, toChildArray } from "preact"; /** @jsx h */
import { ISectionProps } from "./Section";
import { IFixedProps } from "./Fixed";




export type IFixedColumnProps = {
    children?: Array<VNode<IFixedProps | ISectionProps>> | VNode<IFixedProps | ISectionProps>;

};

const filterChild = (child: any) => (
    child?.type?.name == "Section"
    || child?.type?.name == "Column"
    || child?.type?.name == "FixedColumn"
    //|| child?.type?.name == "Fixed"
    || child?.type?.name == "Layout_Section"
    || child?.type?.name == "Layout_Column"
    || child?.type?.name == "Layout_FixedColumn"
    //|| child?.type?.name == "Layout_Fixed"
    || child?.props.as == "Section"
);

export const FixedColumn = (props: IFixedColumnProps) => {

    /*console.log("FixedColumn: ", props, toChildArray(
        props.children
    ));*/

    return (
        <Fragment>
            { 
                toChildArray(
                    props.children
                ).filter((child: any) => child?.props?.weight === "teaser")
            }
            <div className="container mt-5 mb-5">
            
                <div className="row">
                    <div className="col-md-8">
                    {
                        // show a single one promoted at the left hand side
                        toChildArray(
                            props.children
                        ).filter(filterChild).filter((child: any) => child?.props?.weight !== "bottom" && child?.props?.weight !== "teaser")
                    }
                    </div>
                    <div className="col-md-4 pl-4">
                        <div className="sticky-top">
                        {
                            toChildArray(
                                props.children
                            ).filter((child: any) => (child?.type?.name == "Fixed" || child?.type?.name == "Layout_Fixed") && child?.props?.weight !== "teaser")
                        }
                        </div>
                    </div>
                </div>    
            </div>
            {
                toChildArray(
                    props.children
                ).filter(filterChild).filter((child: any) => child?.props?.weight === "bottom")
            }   
        </Fragment>
        

    );
}